const Duration = ({ current, total, mousePosition }) => {
  return (
    <div className="text-sm text-white-dark text-bold flex flex-row items-center">
      {renderAsMinutes(mousePosition > 0 ? mousePosition * total : current)} /{' '}
      {renderAsMinutes(total)}
    </div>
  )
}

function renderAsMinutes(seconds) {
  const mins = Math.floor(seconds / 60)
  const remaining = Math.floor(seconds - mins * 60)
  return (
    <span>
      {mins > 9 ? mins : `0${mins}`}:
      {remaining > 9 ? remaining : `0${remaining}`}
    </span>
  )
}

export default Duration
